'use strict';

import { EwSiteApp } from '../../app/ewsiteapp';
//pikaday
import Pikaday from 'pikaday';
import "pikaday/css/pikaday.css";
//moment
import moment from 'moment';
moment.locale('lt');
//EwSiteApp.requires.push('flow');
//EwSiteApp.requires.push('ui.bootstrap');

//function modalRejectHandler(result){
//	console.log(result);
//}



EwSiteApp.controller('MultiUploadExcavation', ['$scope', '$filter', '$log', '$timeout', function ($scope, $filter, $log, $timeout) {
	$scope.uploaded_files = [];
	//	$scope.errors = [];
	//	$scope.hasError = false;
	$scope.files = [];
	$scope.files.errors = [];
	$scope.files.hasError = false;
	$scope.brez_files = [];
	$scope.brez_files.errors = [];
	$scope.brez_files.hasError = false;
	$scope.max_file_size = 0;
	$scope.fileids = [];
	$scope.brezfileids = [];
	$scope.flowFilesToCancel = [];
	$scope.restored_files = [];

	$timeout(function () {
		if ($scope.$parent && $scope.$parent.postData) {
			var parentFiles = $scope.$parent.postData.files || [];
			var parentBrezFiles = $scope.$parent.postData.brez_files || [];

			if (parentFiles.length) {
				$scope.fileids = angular.copy(parentFiles);
			}
			if (parentBrezFiles.length) {
				$scope.brezfileids = angular.copy(parentBrezFiles);
			}

			var sf = $scope.$parent.postData.session_file_names;
			if (sf) {
				angular.forEach(sf, function (name, id) {
					$scope.restored_files.push({ id: parseInt(id), name: name });
				});
			}

			// Restore the ng-if scope's own counter properties that were lost when
			// the scope was destroyed during back navigation (scope shadowing pattern).
			var totalRestored = parentFiles.length + parentBrezFiles.length;
			if (totalRestored > 0) {
				$scope.$parent.uploads_count = parentFiles.length;
				$scope.$parent.brez_uploads_count = parentBrezFiles.length;
				$scope.$parent.total_upl = totalRestored;
				$scope.transmitToParent();
			}
		}
	}, 0);

	$scope.$on("cancelFlowFiles", function (event, data) {
		$scope.fileids = [];
		$scope.flowFilesToCancel.forEach((file) => {
			file.cancel();
		});
	});
	$scope.closeAlert = function (index) {
		$scope.files.errors.splice(index, 1);
		$scope.brez_files.errors.splice(index, 1);
		//		$scope.errors.splice(index, 1);
	};
	$scope.recalcFileCount = function () {
		//		console.log($scope.$parent.uploads_count);
		//		console.log($scope.excavation_no_project);
		//			if ($scope.excavation_no_project) {
		//				$scope.$parent.brez_uploads_count = 0;
		//			}
		//			$scope.$parent.postData.excavation_no_project = $scope.excavation_no_project;
		$scope.$parent.total_upl = $scope.$parent.uploads_count + $scope.$parent.brez_uploads_count;
	};
	$scope.transmitCountsToParent = function (f) {
		if (f == 'files') {
			$scope.$parent.uploads_count += 1;
		}
		if (f == 'brez_files') {
			$scope.$parent.brez_uploads_count += 1;
		}
		$scope.$parent.total_upl += 1;
	};

	$scope.transmitToParent = function () {
		if (typeof ($scope.$parent.postData.brez_files) !== 'undefined') {
			$scope.$parent.postData.brez_files = $scope.brezfileids;
		}
		if (typeof ($scope.$parent.postData.files) !== 'undefined') {
			$scope.$parent.postData.files = $scope.fileids;
		}
	};

	function flowErrors($file, f) {
		if (typeof ($file.response) !== 'undefined') {
			if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
				return true;
			} else if (typeof ($file.response.message) !== 'undefined') {
				$scope[f].hasError = true;
				$scope[f].errors.push($file.name + ' - ' + $file.response.message);
				return false;
			}
		} else {
			$scope[f].hasError = true;
			$scope[f].errors.push($file.name + ' - Server error');
			return false;
		}
		return null;
	}

	$scope.onFileSuccess = function (f, $file, $message, flowFile) {
		let flow_errors = flowErrors($file, f);
		if (true === flow_errors) {
			$scope.fileids.push($file.response.fileId);
			$scope.flowFilesToCancel.push(flowFile);
			if (!$scope.$parent.postData.session_file_names) $scope.$parent.postData.session_file_names = {};
			$scope.$parent.postData.session_file_names[$file.response.fileId] = $file.name;
			$scope.transmitToParent();
			$scope.transmitCountsToParent(f);
		} else if (false === flow_errors) {
			flowFile.cancel();
		}
	};

	$scope.onFileError = function (f, $file, $message, flowFile) {
		if (false === flowErrors($file, f)) {
			flowFile.cancel();
		}
	};

	$scope.onBrezFileSuccess = function (f, $file, $message, flowFile) {
		let flow_errors = flowErrors($file, f);
		if (true === flow_errors) {
			$scope.brezfileids.push($file.response.fileId);
			$scope.flowFilesToCancel.push(flowFile);
			if (!$scope.$parent.postData.session_file_names) $scope.$parent.postData.session_file_names = {};
			$scope.$parent.postData.session_file_names[$file.response.fileId] = $file.name;
			$scope.transmitToParent();
			$scope.transmitCountsToParent(f);
		} else if (false === flow_errors) {
			flowFile.cancel();
		}
	};

	$scope.onFileAdded = function (f, $file, extensions) {

		var output = false;
		if ($scope.max_file_size > 0 && f == 'brez_files' && $file.size > $scope.max_file_size) {
			$scope.brez_files.hasError = true;
			$scope.brez_files.errors.push($file.name + ' - File too large');
			return output;
		}
		if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
			output = true;
		}
		if (!output) {
			if (f == 'files') {
				$scope.files.hasError = true;
				$scope.files.errors.push($file.name + ' ' + $scope.error_msg);
			}
			if (f == 'brez_files') {
				$scope.brez_files.hasError = true;
				$scope.brez_files.errors.push($file.name + ' ' + $scope.error_msg);
			}
		}
		return output;
	};

	$scope.removeufile = function (fileId) {
		var numId = parseInt(fileId), f = 'files';
		$scope.restored_files = $scope.restored_files.filter(function (rf) { return rf.id !== numId; });
		if ($scope.$parent.postData && $scope.$parent.postData.session_file_names)
			delete $scope.$parent.postData.session_file_names[fileId];
		var idx = $scope.fileids.indexOf(numId);
		if (idx > -1) {
			$scope.fileids.splice(idx, 1);
		} else {
			idx = $scope.brezfileids.indexOf(numId);
			if (idx > -1) { $scope.brezfileids.splice(idx, 1); f = 'brez_files'; }
		}
		$scope.transmitToParent();
		$scope.decreaseUplCount(f);
	};


	$scope.removeUploaded = function (file, f) {
		file.cancel();
		if (f == 'files') {
			var indx = $scope.fileids.indexOf(file.response.fileId);
			if (indx > -1) {
				$scope.fileids.splice(indx, 1);
			}
		}
		if (f == 'brez_files') {
			var indx = $scope.brezfileids.indexOf(file.response.fileId);
			if (indx > -1) {
				$scope.brezfileids.splice(indx, 1);
			}
		}
		if ($scope.$parent.postData && $scope.$parent.postData.session_file_names)
			delete $scope.$parent.postData.session_file_names[file.response.fileId];
		$scope.transmitToParent();
		$scope.decreaseUplCount(f);
	};

	$scope.decreaseUplCount = function (f) {
		if (f == 'files') {
			if ($scope.$parent.uploads_count > 0) {
				$scope.$parent.uploads_count -= 1;
			}
		}
		if (f == 'brez_files') {
			if ($scope.$parent.brez_uploads_count > 0) {
				$scope.$parent.brez_uploads_count -= 1;
			}
		}
		if ($scope.$parent.total_upl > 0) {
			$scope.$parent.total_upl -= 1;
		}
	};
	$scope.excavationWorkDatepickers = function () {
		const startDateField = document.querySelector('.excavation_work_start');
		const endDateField = document.querySelector('.excavation_work_end');

		if (!startDateField || !endDateField)
			return;

		const i18nOptions = {
			previousMonth: 'Praėjęs mėnesis',
			nextMonth: 'Sekantis mėnesis',
			months: moment.localeData().months(),
			weekdays: moment.localeData().weekdays(),
			weekdaysShort: moment.localeData().weekdaysShort()
		};
		function addBusinessDays(date, days) {
			let result = new Date(date);
			let added = 0;
			while (added < days) {
				result.setDate(result.getDate() + 1);
				let day = result.getDay();
				if (day !== 0 && day !== 6) { // skippinam savaitgalius
					added++;
				}
			}
			return result;
		}

		let today = new Date();
		let minDate = addBusinessDays(today, 3); // pridedam +3 darbo dienas

		if (!startDateField.value) {
			endDateField.disabled = true;
		}

		const startDatePicker = new Pikaday({
			field: startDateField,
			firstDay: 1,
			format: 'YYYY-MM-DD',
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			yearRange: [1918, 2050],
			i18n: i18nOptions,
			minDate: minDate,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			},
			onSelect(date) {
				const selectedDate = moment(date);
				const maxEndDate = selectedDate.clone().add(3, 'months').toDate();

				endDateField.disabled = false;
				endDatePicker.setMinDate(date);
				endDatePicker.setMaxDate(maxEndDate);
				endDatePicker.gotoDate(date);
				endDateField.value = '';
			}
		});

		const endDatePicker = new Pikaday({
			field: endDateField,
			firstDay: 1,
			format: 'YYYY-MM-DD',
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			yearRange: [1918, 2050],
			i18n: i18nOptions,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			}
		});
	};

	$scope.excavationWorkDatepickersRangovas = function () {
		const startDateField = document.querySelector('.excavation_work_start_rangovas');
		const endDateField = document.querySelector('.excavation_work_end_rangovas');

		if (!startDateField || !endDateField)
			return;

		const i18nOptions = {
			previousMonth: 'Praėjęs mėnesis',
			nextMonth: 'Sekantis mėnesis',
			months: moment.localeData().months(),
			weekdays: moment.localeData().weekdays(),
			weekdaysShort: moment.localeData().weekdaysShort()
		};

		if (!startDateField.value) {
			endDateField.disabled = true;
		}

		function addBusinessDaysRangovas(date, days) {
			let result = new Date(date);
			let added = 0;
			while (added < days) {
				result.setDate(result.getDate() + 1);
				let day = result.getDay();
				if (day !== 0 && day !== 6) {
					added++;
				}
			}
			return result;
		}
		let minDateRangovas = addBusinessDaysRangovas(new Date(), 2); // pridedam +2 darbo dienas

		const startDatePicker = new Pikaday({
			field: startDateField,
			firstDay: 1,
			format: 'YYYY-MM-DD',
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			yearRange: [1918, 2050],
			i18n: i18nOptions,
			minDate: minDateRangovas,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			},
			onSelect(date) {
				const selectedDate = moment(date);
				const maxEndDate = selectedDate.clone().add(3, 'months').toDate();

				endDateField.disabled = false;
				endDatePicker.setMinDate(date);
				endDatePicker.setMaxDate(maxEndDate);
				endDatePicker.gotoDate(date);
				endDateField.value = '';
			}
		});

		const endDatePicker = new Pikaday({
			field: endDateField,
			firstDay: 1,
			format: 'YYYY-MM-DD',
			showDaysInNextAndPreviousMonths: true,
			enableSelectionDaysInNextAndPreviousMonths: true,
			yearRange: [1918, 2050],
			i18n: i18nOptions,
			toString(date) {
				return moment(date).format('YYYY-MM-DD');
			},
			parse(dateString) {
				return moment(dateString, 'YYYY-MM-DD').toDate();
			}
		});
	};
	$scope.excavationWorkDatepickers();
	$scope.excavationWorkDatepickersRangovas();
}]);

EwSiteApp.controller('ExcavationworkFormCtrl', ['$scope', '$http', '$filter', '$uibModal', '$log', '$timeout', '$sce', 'SessionService', function ($scope, $http, $filter, $uibModal, $log, $timeout, $sce, SessionService) {
	$scope.form_id = "";
	$scope.uploads_count = 0;
	$scope.brez_uploads_count = 0;
	$scope.total_upl = 0;
	$scope.sumbitted = false;
	$scope.message = '';
	$scope.postUrl = jsExcavationwork.post_url;
	$scope.messages = [];
	$scope.nrCheckUrl = jsExcavationwork.nrCheckUrl;
	$scope.navigation = jsExcavationwork.navigation;
	$scope.checkNr = { value: '' };
	$scope.approachedViaDate = false;
	$scope.onRegNrChange = function (val) {
		if (!val) {
			$scope.error_message = '';
			$scope.regNrValid = false;
		}
	};
	$scope.displayStatus = 0;
	$scope.id = 0;
	$scope.checking_nr = false;
	$scope.check_data = {};
	$scope.situation_title = [];
	$scope.loading = false;
	$scope.work_sets_classif = jsExcavationwork.work_sets_classif || [];

	var $cont = $('.main-content');
	var $header = $('.header-container');

	$scope.defaultPostData = function () {
		return {
			form_id: '',
			legal_company_name: '',
			legal_manager_name: '',
			legal_manager_phone: '',
			individual_name: '',
			individual_phone: '',
			acceptance_email: '',
			obj_municipality: '',
			obj_address: '',
			excavation_purpose: '',
			excavation_start: '',
			excavation_end: '',
			excavation_link: '',
			technical_project_nr: '',
			technical_eso_investment_nr: '',
			technical_coord_with_eso_rep_date: '',
			message: '',
			agree_to_terms: false,
			files: [],
			brez_files: [],
			session_file_names: {},
			work_sets: [{
				work_nature: '',
				construction_type: '',
				work_purpose: ''
			}]
		};
	};

	$scope.postData = {
		form_id: '',
		legal_company_name: '',
		legal_manager_name: '',
		legal_manager_phone: '',
		individual_name: '',
		individual_phone: '',
		acceptance_email: '',
		obj_municipality: '',
		obj_address: '',
		excavation_purpose: '',
		excavation_start: '',
		excavation_end: '',
		excavation_link: '',
		technical_project_nr: '',
		technical_eso_investment_nr: '',
		technical_coord_with_eso_rep_date: '',
		message: '',
		agree_to_terms: false,
		files: [],
		brez_files: [],
		session_file_names: {},
		work_sets: [{
			work_nature: '',
			construction_type: '',
			work_purpose: ''
		}]
	};
	$scope.individual_phone = '';
	$scope.legal_manager_phone = '';
	//
	$scope.phoneCheck = function (name, value) {
		$scope.postData[name] = '+370' + value;
	};

	$scope.isFieldInvalid = function(form, index, fieldName) {
		var field = form["worksets[" + (index + 1) + "][" + fieldName + "]"];
		return field && field.$error.required && field.$touched;
	};
	$scope.subtypeMap = jsExcavationwork.construction_types;
	$scope.availableConstructionTypes = [];

	// Work sets classifiers

	$scope.getWorkNatures = function () {
        return $filter('orderBy')($filter('filter')($scope.work_sets_classif, { parent: '0', type: 'theme' }, true), function(item) { return parseInt(item.ord, 10); });
    };

	$scope.getConstructionTypes = function (workNatureId) {
		if (!workNatureId) {
			$scope.availableConstructionTypes = [];
			return;
		}

		var children = $filter('filter')($scope.work_sets_classif, { parent: workNatureId }, true);

		var existingSubtypes = children.map(function(child) {
			return child.subtype;
		});

		let availableConstructionTypes = Object.keys($scope.subtypeMap)
			.filter(function(key) {
				return existingSubtypes.indexOf(key) !== -1;
			})
			.map(function(key) {
				return $scope.subtypeMap[key];
			});
		return availableConstructionTypes;
	};

	// Get work purposes filtered by work nature and construction type, excluding already-selected purposes from other rows
	$scope.getWorkPurposes = function (workNatureId, constructionType, currentSet) {
		if (!workNatureId || constructionType === null || constructionType === undefined || constructionType === '') {
			return [];
		}

		var usedPurposes = $scope.postData.work_sets
			.filter(function(s) { return s !== currentSet && s.work_purpose; })
			.map(function(s) { return s.work_purpose; });

		return $filter('orderBy')($scope.work_sets_classif.filter(function (item) {
			return item.parent == workNatureId && item.subtype == constructionType && usedPurposes.indexOf(item.id) === -1;
		}), function(item) { return parseInt(item.ord, 10); });
	};

	// Handle work nature change
	$scope.onWorkNatureChange = function (set) {
		set.construction_type = '';
		set.work_purpose = '';

		var types = $scope.getConstructionTypes(set.work_nature);
		if (types && types.length > 0) {
			var netaikoma = types.find(function(item) { return item.id == 0; });
			if (netaikoma) {
				set.construction_type = netaikoma.id;
			}
		}
	};

	$scope.isConstructionTypeEmpty = function (set) {
		return !set.work_nature || set.construction_type === null || set.construction_type === undefined || set.construction_type === '';
	};

	// Handle construction type change
	$scope.onConstructionTypeChange = function (set) {
		// Reset dependent field
		set.work_purpose = '';
	};


	$scope.getIconPath = function (form) {
		if (form.image) {
			return form.image;
		}
		return form.icon2;
	};

	$scope.setDisplayStatus = function (btn) {
		let title = '';
		if (arguments[1]) {
			title = arguments[1];
		}
		for (var i = 0, len = $scope.navigation.length; i < len; i++) {
			if ($scope.navigation[i].id == btn.question_id) {
				$scope.id = i;
				break;
			}
		}

		document.querySelector('.index_container').scrollIntoView({
			behavior: 'smooth'
		});
		if (btn.question_id > 0 && !title) {
			$scope.situation_title.push(btn.title);
		} else if (title) {
			$scope.situation_title.push(title);
		}
		if (btn.question_id == 0) {
			$scope.situation_title = [];
		}
		$scope.displayStatus = btn.question_id;
	};

	$scope.resetForm = function (btn) {
		$scope.regNrValid = false;
		$scope.error_message = '';
		$scope.messages = [];
		$scope.message = '';
		$scope.checking_nr = false;
		$scope.submited = false;
		$scope.approachedViaDate = false;
		if (btn.back_id >= 0) {
			btn.question_id = 0;

			for (var i = 0, len = $scope.navigation.length; i < len; i++) {
				if ($scope.navigation[i].id == btn.question_id) {
					$scope.id = i;
					break;
				}
			}
			$scope.displayStatus = 0;
			$scope.check_data = {};
			$scope.postData = $scope.defaultPostData();
			$scope.checkNr.value = '';
			$scope.$broadcast("cancelFlowFiles", {});

			$scope.situation_title = [];
		} else {
			$scope.navigation = jsExcavationwork.navigation;
			$scope.setDisplayStatus(0);
		}
	};

	$scope.stepBack = function (btn) {
		$scope.regNrValid = false;
		$scope.error_message = '';
		$scope.messages = [];
		$scope.message = '';
		$scope.checking_nr = false;
		$scope.submited = false;
		if (btn.back_id >= 0) {
			if(btn.id === 40){
				if($scope.postData.form_id===1){
					btn.back_id = 20;
				}
				if($scope.postData.form_id===2){
					btn.back_id = 21;
				}
				for (let i = 0; i < $scope.postData.work_sets.length; i++) {
					let type = $scope.postData.work_sets[i].construction_type;
					if (type == '1') {
						btn.back_id = $scope.approachedViaDate ? 1 : 2;
						break;
					}
				}
			}
			btn.question_id = btn.back_id;

			for (var i = 0, len = $scope.navigation.length; i < len; i++) {
				if ($scope.navigation[i].id == btn.question_id) {
					$scope.id = i;
					break;
				}
			}
			$scope.displayStatus = btn.question_id;

			if ($scope.situation_title.length > 0) {
				$scope.situation_title.splice($scope.situation_title.length - 1, 1);
			}

			if ($scope.displayStatus === 1) {
				$scope.check_data = {};
				$scope.approachedViaDate = false;
//				$scope.postData = $scope.defaultPostData();
//				$scope.$broadcast("cancelFlowFiles", {});
			}
			if ($scope.displayStatus === 0) {
				$scope.postData = $scope.defaultPostData();
				$scope.checkNr.value = '';
				$scope.$broadcast("cancelFlowFiles", {});
			}

		} else {
			$scope.navigation = jsExcavationwork.navigation;
			$scope.setDisplayStatus(0);
		}
		//		$scope.initTooltip();
	};

	$scope.getCurrentQuestions = function (btn) {
		if (btn.question_id === 4) {
			$scope.postData.form_id = 1;
			$scope.postData.technical_project_nr = $scope.check_data.registration_nr;
		} else if (btn.question_id === 6) {
			$scope.postData.form_id = 1;
		} else if (btn.question_id === 8) {
			$scope.postData.form_id = 2;
			$scope.postData.technical_project_nr = $scope.check_data.registration_nr;
		} else if (btn.question_id === 12) {
			$scope.postData.form_id = 2;
		} else if (btn.question_id === 7) {
			$scope.postData.form_id = 3;
		} else if (btn.question_id === 20) {
			$scope.postData.form_id = 1; // Juridinis
		} else if (btn.question_id === 21) {
			$scope.postData.form_id = 2; // Fizinis
		}

		$scope.setDisplayStatus(btn);
		fixView();

		//		$scope.initTooltip();
	};

	$scope.addWorkSet = function () {
		if ($scope.postData.work_sets.length >= 10) {
			return;
		}

		$scope.postData.work_sets.push({
			work_nature: '',
			construction_type: '',
			work_purpose: ''
		});
	};

	$scope.removeWorkSet = function (index) {
		if ($scope.postData.work_sets.length > 1) {
			$scope.postData.work_sets.splice(index, 1);
		}
	};

	$scope.validateAndProceed = function (btn) {

		// Show Reg Nr check (status 1) if any work_set is "Nauja statyba" (1), otherwise go straight to form
		let goToForm = true;
		for (let i = 0; i < $scope.postData.work_sets.length; i++) {
			let type = $scope.postData.work_sets[i].construction_type;
			if (type == '1') {
				goToForm = false;
				break;
			}
		}
		if (goToForm) {
			let newBtn = {
				question_id: 40,
				back_id: btn.question_id,
				title: btn.title
			};
			$scope.setDisplayStatus(newBtn);
		} else {
			let newBtn = {
				question_id: 1,
				back_id: btn.id,
				title: btn.title
			};
			$scope.setDisplayStatus(newBtn);
		}
		fixView();
	};


	$scope.teiktiDuomenis = function (btn) {

			let newBtn = {
				question_id: 40,
				back_id: btn.back_id, // Back to 20 or 21
				title: 'Teikti duomenis'
			};
			$scope.setDisplayStatus(newBtn);
	};

	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};

	$scope.checkRegNr = function (check_registration_nr, btn) {
		$scope.checking_nr = true;
		if ($scope.nrCheckUrl !== '' && check_registration_nr !== '') {
			$http({
				method: 'POST',
				url: $scope.nrCheckUrl,
				data: {
					nr: check_registration_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				$scope.regNrValid = response.data.success;
				if (response.data.success) {
					$scope.approachedViaDate = false;
					$scope.check_data = response.data.data;
					// Užfiksuojame patikrintą trečiųjų asmenų projekto numerį, kad jis būtų išsaugotas
					// kartu su kasimo darbų įrašu (admin. matys jį kaip nuorodą).
					$scope.postData.technical_project_nr = response.data.data.registration_nr;
					let nr = btn.title + ' ' + check_registration_nr;
					$scope.setDisplayStatus(btn, nr);
				} else {
					$scope.error_message = response.data.message;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
		}
	};

	$scope.checkRegNrOrDate = function (nr, date, btn) {
		if (nr) {
			$scope.checkRegNr(nr, btn);
		} else if (date) {
			$scope.approachedViaDate = true;
			// Pasirinkus „pagal datą", projekto numerio nėra – išvalome, kad neliktų ankstesnės reikšmės.
			$scope.postData.technical_project_nr = '';
			let newBtn = {
				question_id: 40,
				back_id: 1,
				title: btn.title
			};
			$scope.setDisplayStatus(newBtn);
			fixView();
		}
	};

	$scope.termsModal = function () {
		var template = 'excavationwork/modal.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'ExcavationworkPreviewCtrl',
			//size: 'sm',
			resolve: {
				item: function () {
					//return true;
				}
			}
		});

		//		modalInstance.result.then(function(result){
		//
		//		}, modalRejectHandler);
	};

	var hideInfoContainers = function () {
		var $info = $('.index_container > .white_bg > .info_container');
		var $error = $('.index_container > .white_bg > .error_container');

		if ($info.length > 0 && $info.is(":visible")) {
			$info.remove();
		}

		if ($error.length > 0 && $error.is(":visible")) {
			$error.remove();
		}
	};

	$scope.onFormSelect = function () {
		//		$scope.initTooltip();
		hideInfoContainers();
	};


	$scope.submitForm = function (form) {

		$scope.trySubmit = true;
		if ($scope.postUrl && $scope.postUrl !== '') {
			$scope.loading = true;
			if (typeof jsExcavationwork.recaptcha !== 'undefined') {
				grecaptcha.ready(function () {
					grecaptcha.execute(jsExcavationwork.recaptcha.siteKey, { action: 'submit' }).then(function (token) {
						$scope.postData.recaptchaResponse = token;
						$scope.submitFormPost(form);
					});
				});
			} else {
				$scope.submitFormPost(form);
			}
		} else {
			form.$submitted = false;
		}
	};

	$scope.submitFormPost = function (form) {
		$scope.messages = [];
		if (typeof jsExcavationwork.recaptcha !== 'undefined') {
			$scope.postData[jsExcavationwork.recaptcha.field] = $scope.postData.recaptchaResponse;
		}
		$http({
			method: 'POST',
			url: $scope.postUrl,
			data: $scope.postData,
			xsrfCookieName: secure_xsrf_name,
			xsrfHeaderName: 'X-' + secure_xsrf_name
		}).then(function (response) {
			if (response.data.success) {
				form.$setPristine();
				form.$setUntouched();
				form.$submitted = false;
				$scope.message = response.data.message;
				$scope.submited = true;
			} else {
				form.$submitted = false;
				if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
					$scope.messages = response.data.errors;
				}
			}
			fixView();
		}).then(function () {
			$scope.loading = false;
		});
	};

	var fixView = function () {
		if ($cont.offset().top < $(window).scrollTop()) {
			$('html, body').animate({
				scrollTop: $cont.offset().top - $header.outerHeight(true) - 20
			}, 250);
		}
	};

	SessionService.init();

	$scope.$on('$destroy', function () {
		SessionService.stop();
	});
}]);

EwSiteApp.controller('ExcavationworkPreviewCtrl', ['$scope', '$uibModalInstance', 'item', function ($scope, $uibModalInstance, item) {
	$scope.item = angular.copy(item);
	$scope.save = function () {
		$uibModalInstance.close($scope.item);
	};
	$scope.cancel = function () {
		for (var i in $scope.require) {
			$scope.require[i] = false;
		}
		$uibModalInstance.dismiss();
	};
}]);

EwSiteApp.directive('notOnlyNumbers', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attrs, ngModel) {
			ngModel.$validators.notOnlyNumbers = function (modelValue, viewValue) {
				if (ngModel.$isEmpty(modelValue)) {
					return true;
				}
				// Check if the value consists ONLY of numbers
				return !/^\d+$/.test(viewValue);
			};
		}
	};
});

EwSiteApp.directive('onlyLettersInput', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attr, ngModelCtrl) {
			function fromUser(text) {
				var transformedInput = text.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0430-\u044f ]/g, '');
				if (transformedInput !== text) {
					ngModelCtrl.$setViewValue(transformedInput);
					ngModelCtrl.$render();
				}
				return transformedInput;
			}
			ngModelCtrl.$parsers.push(fromUser);
		}
	};
});

EwSiteApp.directive('select2Init', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			// Initialize Select2 on the element
			$timeout(function () {
				$(element).select2({
					minimumResultsForSearch: Infinity
				});

				// Handle dynamic placeholder if the element has the class
				if ($(element).hasClass('select2_with_dynamic_placeholder')) {
					$(element).select2({
						minimumResultsForSearch: Infinity,
						placeholder: $(element).data('placeholder')
					});
				}

				// Watch for changes in the select element
				scope.$watch(function () {
					return element[0].innerHTML;
				}, function (newVal, oldVal) {
					if (newVal !== oldVal) {
						$timeout(function () {
							$(element).trigger('change'); // Reinitialize Select2 if content changes
						});
					}
				});
			});
		}
	};
}]);

// Įvynioja info bloko (.tekstas-oranziniame-fone) turinį į baltą bloką pagal Figma.
// Daroma per kodą, kad veiktų visose aplinkose nepriklausomai nuo CMS turinio. Idempotentiška.
EwSiteApp.directive('wrapAlertWhiteBlock', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		link: function (scope, element) {
			$timeout(function () {
				$(element).find('.tekstas-oranziniame-fone').each(function () {
					var $orange = $(this);
					if (!$orange.children('.tekstas-baltame-fone').length) {
						$orange.wrapInner('<span class="tekstas-baltame-fone"></span>');
					}
				});
			});
		}
	};
}]);
